let oldTestamentBooks : any = {
    Genesis: {numChapters: 50},
    Exodus: {numChapters: 40},
    Leviticus: {numChapters: 27},
    Numbers: {numChapters: 36},
    Deuteronomy: {numChapters: 34},
    Joshua: {numChapters: 24},
    Judges: {  numChapters: 21},
    Ruth: {  numChapters: 4},
    "1 Samuel":  {numChapters: 31},
    "2 Samuel":  {numChapters: 24},
    "1 Kings":  {numChapters: 22},
    "2 Kings": {numChapters: 25},
    "1 Chronicles": {numChapters: 29},
    "2 Chronicles": {numChapters: 36},
    Ezra: {numChapters: 10},
    Nehemiah: {numChapters: 13},
    Esther: {numChapters: 10},
    Job: {numChapters: 42},
    Psalms: {numChapters: 150},
    Proverbs: {numChapters: 31},
    Ecclesiastes: {numChapters: 12},
    "Song of Solomon": {numChapters: 8},
    Isaiah: {numChapters: 66},
    Jeremiah: {numChapters: 52},
    Lamentations: {numChapters: 5},
    Ezekiel: {numChapters: 48},
    Daniel: {numChapters: 12},
    Hosea: {numChapters: 14},
    Joel: {numChapters: 3},
    Amos: {numChapters: 9},
    Obadiah: {numChapters: 1},
    Jonah: {numChapters: 4},
    Micah: {numChapters: 7},
    Nahum: {numChapters: 3},
    Habakkuk: {numChapters: 3},
    Zephaniah: {numChapters: 3},
    Haggai: {numChapters: 2},
    Zechariah: {numChapters: 14},
    Malachi: {numChapters: 4},
}

export {oldTestamentBooks};